import { createViewData } from "../../App/ViewData"
import type { IDay, ITrack, ITrip } from "../../Types"
import type { TripWriters } from "./writers"

export interface TripDataViewData {
  trip: ITrip;
  days: IDay[] | undefined;
  tracks: ITrack[] | undefined;
  details: boolean;
  setDetails: (value: boolean) => void;
  writers: TripWriters;
}

export const { Context: TripDataContext, useData: useTripData } =
  createViewData<TripDataViewData>("TripDataView");
